import { getStorageItem } from "../redux/middleware/localStorage";
import ServiceHelper from "../../src/services/serviceHelper";
import moment from "moment";
//const DEV_GATEWAY = "https://fa-ai-dcap-prod.azurewebsites.net/api/";
//const DEV_GATEWAY = "https://fa-ai-dcap-prod-copy.azurewebsites.net/api/";

const USER_GATEWAY = "https://user-login-api.azurewebsites.net/";

const CHEP_PYTHON_NEW_GATEWAY = "https://azfun-chep-user-login-python-prod-001.azurewebsites.net/api/"

const CHEP_GATEWAY = "https://azfun-chep-dcap-dev-001.azurewebsites.net/";

const CHEP_CHANGE_GATEWAY = "https://azfun-chep-userlogin-dev-001.azurewebsites.net/";
// for chep-dcap
const DEV_GATEWAY = "https://azfun-chep-dcap-prod-001.azurewebsites.net/api/";

// const DEV_GATEWAY = "https://azfun-jbs-dcap-dev-001.azurewebsites.net/api/";
// const USER_GATEWAY = "https://azfun-jbs-userlogin-dev-001.azurewebsites.net/";
/**
 * 
 * @param userId Get Model based on User Id
 */
export const refreshTokenCall = () => {
    const signInUserSession = localStorage.getItem("signInUserSession");
    const user = signInUserSession && JSON.parse(signInUserSession);
    const refreshToken = user.refresh_token
    return refreshToken;
}
const getUserId = () => {
    const signInUserSession = localStorage.getItem("signInUserSession");
    const user = signInUserSession && JSON.parse(signInUserSession);
    const userId = user && user.user.oid;
    return userId;
};
export const accessToken = () => {
    const signInUserSession = localStorage.getItem("signInUserSession");
    const user = signInUserSession && JSON.parse(signInUserSession);
    const accessToken = user && user.access_token;
    const headers = { "Content-Type": "application/json,image/jpeg,application/pdf", "Authorization": `Bearer ${accessToken}`, "cache-control": "no-cache" };
    // return accessToken;
    return headers
};
export const accessTokenData = () => {
    const signInUserSession = localStorage.getItem("signInUserSession");
    const user = signInUserSession && JSON.parse(signInUserSession);
    const accessToken = user && user.access_token;
    return accessToken;
};

export const headers = { "Content-Type": "application/json", "Authorization": `Bearer ${accessTokenData()}`, "cache-control": "no-cache" };
export const loginHeaders = { "Content-Type": "application/json", "cache-control": "no-cache" };
export const allModelsEndPoint = () => (`${DEV_GATEWAY}project-details?db=dcap&user_id=${getUserId()}`);
//export const deleteModelEndPoint = (model: any) => (`${DEV_GATEWAY}project-details?db=dcap&delete_project_name=${model.project_name}-${getUserId()}`);
export const deleteModelEndPoint = (model: any) => (`${DEV_GATEWAY}project-details?db=dcap&delete_project_name=${model.project_name}-${getUserId()}&user_id=${getUserId()}`);

/**
 * Password change
 */
export const changePassword = () => (`${CHEP_PYTHON_NEW_GATEWAY}changepassword`);


/**
 * Queues http URL's
 */
export const createUserQueue = (queueObject: any) => (`${DEV_GATEWAY}store-queues?project_name=${queueObject.project_name}-${getUserId()}&queue_name=${queueObject.queue_name}&ops=load`);
export const deleteUserQueue = (queueObject: any) => (`${DEV_GATEWAY}store-queues?project_name=${queueObject.project_name}&queue_name=${queueObject.queue_name}&ops=delete`);
export const userAllQueues = (projectName: string) => (`${DEV_GATEWAY}store-queues?project_name=${projectName}-${getUserId()}&ops=view`);
export const deleteTestFiles = (userId: string) => (`${DEV_GATEWAY}delete-from-container`);
export const getAllInvalidFiles = (fileType: string) => (`${DEV_GATEWAY}list-error-files?name=${fileType}`);
export const submitErrorProcess = (projectName:String,fileType: string) => (`${DEV_GATEWAY}error-handling?project_name=${projectName}&filename=${fileType}`);
export const invoiceManagement = () => (`${DEV_GATEWAY}portal_page?user_id=${getUserId()}`);
export const postProcessingXMLPathURL =(xml_file_path: string) => (`${DEV_GATEWAY}post-generate-pdf-json?xml_file_path=${xml_file_path}`);
export const postProcessingEditTags =(xml_file_path: string) => (`${DEV_GATEWAY}post-edit-json?xml_file_path=${xml_file_path}`);

//documentmanagement for internal
//export const documentMangement = () => (`${DEV_GATEWAY}document_portal_page?user_id=${getUserId()}&table_name=documentsmro`);
//export const documentMangementTagsSave = (file_name) => (`${DEV_GATEWAY}post-process-documents?file_name=${file_name}&user_id=${getUserId()}`);

// documentmanagement for SCU
// export const documentMangement = () => (`${DEV_GATEWAY}document_portal_page_scu?user_id=${getUserId()}&table_name=documentsmro`);
// export const documentMangementTagsSave = (file_name) => (`${DEV_GATEWAY}post-process-documents-scu?file_name=${file_name}&user_id=${getUserId()}`);


//chep API

export const documentMangement = () => (`${DEV_GATEWAY}document_portal_page_sap?table_name=SAPOrderDetails`);

//export const documentMangementTagsSave = (id) => (`${DEV_GATEWAY}post-process-documents-sap?request_id=${id}`);
export const documentMangementTagsSave = (id) => (`${DEV_GATEWAY}post-process-documents-sap?request_id=${id}&user_id=${getUserId()}`);

export const documentMangementTagsException = (row_key,id) => (`${DEV_GATEWAY}exception-send-email?row_key=${row_key}&request_id=${id}`);
 
//https://azfun-chep-dcap-dev-001.azurewebsites.net/api/exception-send-email?row_key=0c1b89e5-4f84-4614-bf79-510abd2eea0c&request_id=3acc168c-65c6-4e2e-87ad-f6d515f23a58

export const invoiceManagentTagsSave = (file_name) => (`${DEV_GATEWAY}post-process-invoice?file_name=${file_name}&user_id=${getUserId()}`);



/**
 * batch process
 */
export const processedFileEndPoint = (projectName, queueName) => (`${DEV_GATEWAY}operations-process?project_name=${projectName}-${getUserId()}&queue_name=${queueName}`);
export const dataRevisionEndPoint = (projectName) => (`${DEV_GATEWAY}data-revision?project_name=${projectName}-${getUserId()}`);
export const processBatchPredictionEndPoint = (projectName, queueName) => (`${DEV_GATEWAY}batch-prediction?project_name=${projectName}-${getUserId()}&queue_name=${queueName}`);
export const analyseResultEndPoint = (projectName, queueName, fileName) => (`${DEV_GATEWAY}operations-process?project_name=${projectName}-${getUserId()}&queue_name=${queueName}&file_name=${fileName}`)
/**
 * Upload files
 */
export const deleteFileEndPoint = (projectName, queueName, fileName) => (`${DEV_GATEWAY}delete-blob?project_name=${projectName}-${getUserId()}&keyword=${queueName}&file_name=${fileName}`);
export const analysisGetEndPoint = (modelName: any, analysis) => (`${DEV_GATEWAY}training-model?name=${modelName}-${getUserId()}&analysis=${analysis}&user_id=${getUserId()}`);
//export const fileUploadEndPoint = (projectName, filename, keyword, schemaParam) => (`${DEV_GATEWAY}upload-files?project_name=${projectName}-${getUserId()}&file_name=${filename}&keyword=${keyword}&schema=${schemaParam}`);

export const fileUploadEndPoint = (projectName, filename, keyword, schemaParam, typeParam) => (`${DEV_GATEWAY}upload-files?project_name=${projectName}-${getUserId()}&file_name=${filename}&keyword=${keyword}&schema=${schemaParam}&type=${typeParam}`);


//export const fileUploadEndPoint_PreBuilt= (projectName, filename, keyword, schemaParam, typeParam) => (`${DEV_GATEWAY}invoice-prebuilt-upload-files?file_name=${filename}`);
export const fileUploadEndPoint_PreBuilt= (projectName, filename, keyword, schemaParam, typeParam) => (`${DEV_GATEWAY}invoice-prebuilt-upload-files?project_name=${projectName}&file_name=${filename}`);

//https://azfun-chep-dcap-dev-001.azurewebsites.net/api/invoice-prebuilt-upload-files?file_name=354_PO_300000009212742_4148356_0 (1).pdf

/**
 * Files URL
 */
export const LoadUserFilesEndPointBasedOnModel = (projectName, queueName) => (`${DEV_GATEWAY}list-blobs?project_name=${projectName}-${getUserId()}&keyword=${queueName}`);

//export const LoadUserFilesEndPointBasedOnModel_Chep = (projectName, queueName) => (`${DEV_GATEWAY}list-blobs?project_name=invoices-prebuilt&keyword=na`);
export const LoadUserFilesEndPointBasedOnModel_Chep = (projectName, queueName) => (`${DEV_GATEWAY}list-blobs?project_name=${projectName}&keyword=invoice_prebuilt`);

export const generateOcrEndPoint = (projectName, fileName) => (`${DEV_GATEWAY}ocr?project_name=${projectName}-${getUserId()}&file_name=${fileName}`);
export const ocrForIndividualFile = (fileObject: any) => (`${DEV_GATEWAY}listblob-single?project_name=${fileObject.modelName}-${getUserId()}&keyword=${fileObject.keyword}&file_name=${fileObject.file_name}`)
/**
 * Create Model
 */
export const createModelEndPoint = (modelObject: any) => (`${DEV_GATEWAY}user-project-details?project_name=${modelObject.project_name}-${getUserId()}&user_id=${getUserId()}&schema=${modelObject.schema}&project_type=${modelObject.project_type}`);

/** User Defined Validation and Transformation  */
export const loadEndPoint = (endPoint) => (`${DEV_GATEWAY}view-endpoints?project_name=${endPoint.project_name}-${getUserId()}&endpoint_type=${endPoint.endpoint_type}&user_id=${getUserId()}`)

export const loadEndPointByUser = (endPoint) => (`${DEV_GATEWAY}view-endpoints-by-user?project_name=${endPoint.project_name}-${getUserId()}&user_id=${getUserId()}`)
export const enableDisableEndPoint = (endPoint) => (`${DEV_GATEWAY}enable-disable?project_name=${endPoint.project_name}-${getUserId()}&endpoint_type=${endPoint.endpoint_type}&endpoint_name=${endPoint.endpoint_name}&status=${endPoint.active_status}&user_id=${getUserId()}`)
//old createUserEndPoint till 02102020
//export const createUserEndPoint = (endPoint) => (`${DEV_GATEWAY}store-endpoints?project_name=${endPoint.project_name}-${getUserId()}&endpoint_type=${endPoint.endpoint_type}&active_status=${endPoint.active_status}&category=${endPoint.category}`)

//old createUserEndPoint from 02102020
export const createUserEndPoint = (endPoint) => (`${DEV_GATEWAY}store-endpoints?
project_name=${endPoint.project_name}-${getUserId()}&endpoint_type=${endPoint.endpoint_type}
&active_status=${endPoint.active_status}&category=${endPoint.category}&user_id=${getUserId()}`)


export const deleteEndPoint = (endPoint) => (`${DEV_GATEWAY}delete-endpoints?project_name=${endPoint.project_name}-${getUserId()}&endpoint_type=${endPoint.endpoint_type}&endpoint_name=${endPoint.endpoint_name}&endpoint=${endPoint.endpoint}&user_id=${getUserId()}`)
// export const aiDcapRegister = (body) => (`${DEV_GATEWAY}user-registration?first_name=${body.firstName}&last_name=${body.lastName}&email=${body.mail}&contact_no=${body.contactNumber}&tenant_name=${body.tenantName}&tenant_id=${body.tenantId}&role=${body.role}`);
export const aiDcapRegister = () => (`${CHEP_PYTHON_NEW_GATEWAY}CreateUser`);


/**User Register */
export const userRegisterEndPoint = () => (`${USER_GATEWAY}api/registeruser?`)

/**Document Prediction */
export const documentPredictionEndPoint = (projectName,fileName,outPutFormat) => (`${DEV_GATEWAY}document-prediction?project_name=${projectName}-${getUserId()}&file_name=${fileName}&output_format=${outPutFormat}&keyword=testing&user_id=${getUserId()}`)

/* delete blob*/
export const deleteBlobEndPoint = (projectName,fileName) => (`${DEV_GATEWAY}delete-blob?project_name=${projectName}-${getUserId()}&keyword=testing&file_name=${fileName}`)
/**User Register */
// export const userRegisterEndPoint = () => (`https://user-login-api.azurewebsites.net/api/registeruser`);

export const forgotPasswordEndPoint = () => (`${CHEP_PYTHON_NEW_GATEWAY}ForgotPassword`)
/** Refresh Token */
export const refreshTokenEndPoint = () => (`${USER_GATEWAY}api/refreshtoken`)



export const analysisCVGetEndPoint = (projectid,iterationName) => (`${DEV_GATEWAY}cv_train_id?projectid=${projectid}&iterationName=${iterationName}`);

export const analysisCustomVisionGetEndPoint = (project_name,user_id) => (`${DEV_GATEWAY}od-training-response?project_name=${project_name}&user_id=${user_id}`);
export const analysisCustomVisionTriggerGetEndPoint = (projectid) => (`${DEV_GATEWAY}od-training-trigger`);

/**Document Prediction */
export const documentPredictionimgEndPoint = (projectName,fileName,outPutFormat) => (`${DEV_GATEWAY}od-prediction?project=${projectName}-${getUserId()}&file_name=${fileName}&keyword=testing&user_id=${getUserId()}`)


export const queuefileUploadEndPoint = (filename) => (`${DEV_GATEWAY}upload-to-container?file_name=${filename}&schema=schema`);
export const LoadUserFilesforQueueEndPoint = (modelName) => (`${DEV_GATEWAY}list-blobs-from-container`);


//export const createSAPOrderEndPoint = (endPoint) => (`${DEV_GATEWAY}store-data-sap?
//project_name=${endPoint.project_name}-${getUserId()}&invoiceNo=${endPoint.invoiceNo}
//&purchaseReq=${endPoint.purchaseReq}&user_id=${getUserId()}`)


export const createSAPOrderEndPoint = (endPoint) => (`${DEV_GATEWAY}store-data-sap`);


export const runAnalysisPrebuiltInvoice = (file_name:string) => (`${DEV_GATEWAY}invoice_prebuilt?file_name=${file_name}&user_id=${getUserId()}`);
  

//order management
//  https://azfun-chep-dcap-dev-001.azurewebsites.net/api/order-details-page


export const getOrderManagementDetailsEndPoint = () => (`${DEV_GATEWAY}order-details-page`);

//https://azfun-chep-dcap-dev-001.azurewebsites.net/api/order-details-page?fromdate=2021-06-07&todate=2021-06-05
export const getOrderManagementDetailsEndPointByDate = (fromdate,todate) => (`${DEV_GATEWAY}order-details-page?fromdate=${fromdate}&todate=${todate}`);

export const documentMangementEndPointByDate = (fromdate,todate) => (`${DEV_GATEWAY}document_portal_page_sap?table_name=SAPOrderDetails&fromdate=${fromdate}&todate=${todate}`);
//export const orderMangementTagsSave = (id) => (`${DEV_GATEWAY}order-details-page-edited?request_id=${id}&user_id=${getUserId()}`);
export const orderMangementTagsSave = (id,row_key) => (`${DEV_GATEWAY}order-details-page-edited?request_id=${id}&user_id=${getUserId()}&row_key=${row_key}`);
export const orderMangementTagsAdd = (id) => (`${DEV_GATEWAY}insert-into-orderdetails?request_id=${id}`);

export const orderMangementTags_IrrEmail = (mail_relevance,request_id) => (`${DEV_GATEWAY}irrelevantemails-in-order-management?mail_relevance=${mail_relevance}&request_id=${request_id}`);

//https://azfun-chep-dcap-dev-001.azurewebsites.net/api/irrelevantemails-in-order-management?mail_relevance=irrelevant&request_id=a8450b85-e74a-4582-9965-f799261e6308
//https://azfun-chep-dcap-dev-001.azurewebsites.net/api/insert-into-orderdetails?request_id=d4a16f0d-fdd3-4b3d-be59-024a76498aae
//https://azfun-chep-dcap-dev-001.azurewebsites.net/api/order-details-page-edited?request_id=c748b281-917a-402f-966b-cffc712d285b

//https://azfun-chep-dcap-dev-001.azurewebsites.net/api/fetch-sas-urls?request_id=760e91a8-7437-483b-86c2-d40e00a2eb6d

export const getOrderMgtdocUrlsEndpoint = (id) => (`${DEV_GATEWAY}fetch-sas-urls?request_id=${id}`);


export const getPredictionResult_invoice = (project_name, file_name) => (`${DEV_GATEWAY}invoice_prebuilt?project_name=${project_name}&file_name=${file_name}&user_id=${getUserId()}`);
 
//https://azfun-chep-dcap-dev-001.azurewebsites.net/api/invoice_prebuilt?project_name=invoice-11&file_name=test-invoice-11.pdf&user_id=2541c8e9-3e3e-418a-9e21-818657238210

//https://azfun-chep-dcap-dev-001.azurewebsites.net/api/update-status-order-management?request_id=90d3b698-d496-4d58-90c7-e3cf23f03d08&user_id=2541c8e9-3e3e-418a-9e21-818657238210&status=Completed

//export const orderMgt_UpdateStatus_OLD = (request_id,status,rowkey) => (`${DEV_GATEWAY}update-status-order-management?request_id=${request_id}&user_id=${getUserId()}&status=${status}&row_key=${rowkey}`);
export const orderMgt_UpdateStatus= (request_id,status) => (`${DEV_GATEWAY}update-status-order-management?request_id=${request_id}&status=${status}&user_id=${getUserId()}`);
//https://azfun-chep-dcap-dev-001.azurewebsites.net/api/update-status-doc-management?request_id=90d3b698-d496-4d58-90c7-e3cf23f03d08&user_id=2541c8e9-3e3e-418a-9e21-818657238210&status=Completed

export const docMgt_UpdateStatus_old = (request_id,status,rowkey) => (`${DEV_GATEWAY}update-status-doc-management?request_id=${request_id}&user_id=${getUserId()}&status=${status}&row_key=${rowkey}`);

export const docMgt_UpdateStatus = (request_id,status) => (`${DEV_GATEWAY}update-status-doc-management?request_id=${request_id}&status=${status}&user_id=${getUserId()}`);



//https://azfun-chep-dcap-dev-001.azurewebsites.net/api/lock_mechanism?request_id=770f7ddc-7baf-49d2-8e9c-2de40ceb2606&row_key=7c5d63ae-7b1a-4ec4-8eb6-891cdc431c42&keyword=check
export const orderMgt_Lock_Release_Endpoint = (request_id,row_key,keyword) => (`${DEV_GATEWAY}lock_mechanism?request_id=${request_id}&keyword=${keyword}&user_id=${getUserId()}&lock_time=${moment().format("MM/DD/YYYY[T]HH:mm:ss")}`);
export const orderMgt_Lock_check_Endpoint = (request_id,row_key,keyword) => (`${DEV_GATEWAY}lock_mechanism?request_id=${request_id}&keyword=${keyword}&user_id=${getUserId()}&lock_time=${moment().format("MM/DD/YYYY[T]HH:mm:ss")}`);

//https://azfun-chep-dcap-dev-001.azurewebsites.net/api/lock_mechanism?
//request_id=b7f34078-aa4d-4426-9322-4a90a64305b7&row_key=1a55ff6b-f480-42d2-8954-834ce2f03719&
//keyword=check&user_id=2541c8e9-3e3e-418a-9e21-818657238210&lock_time=08/28/2021T18:56:30
export const orderMgt_Lock_Apply_Endpoint = (request_id,row_key) => (`${DEV_GATEWAY}lock_mechanism?request_id=${request_id}`);

//
export const loadBusinessUsersEndPoint = () => (`${DEV_GATEWAY}get-user-features`);
export const loadBusinessUsersByIdEndPoint = (requestor_id) => (`${DEV_GATEWAY}get-user-features?user_role=${requestor_id}`);

//https://azfun-chep-dcap-dev-001.azurewebsites.net/api/user-features-list

export const updateUserFeaturesByIdEndPoint = (user_email) => (`${DEV_GATEWAY}user-features-list?user_email=${user_email}&role=${""}`);
export const insertUserFeaturesByIdEndPoint = (user_email,user_role) => (`${DEV_GATEWAY}user-features-list?user_email=${user_email}&role=${user_role}`);
//https://azfun-chep-dcap-dev-001.azurewebsites.net/api/get-user-features?user_role=2636f98a-2f23-4d26-846e-6a9d6e210709